const API_URL = `${window.location.protocol}//${window.location.host}/api/nh/product-filtering`;
const SEARCH_URL = `${window.location.protocol}//${window.location.host}/api/nh/search?query=`;
import { IfcProductFilteringRequest } from "Interfaces/IfcProductFilteringRequest";

export default class FilteringService {
	private _initialized: boolean = false;

	// Insure that there's a single instance of FilterService shared by all components
	static _instance: FilteringService;

	static getInstance(): FilteringService {
		return FilteringService._instance || new FilteringService();
	}

	get initialized() {
		return this._initialized;
	}

	constructor() {
		if (!FilteringService._instance) {
			FilteringService._instance = this;
		}

		return FilteringService._instance;
	}

	static fetchSearchData(query?:any) {
		return fetch(SEARCH_URL+query).then((response) => {
			return response.json().then((data) => {
				return data;
			}).catch((err) => {
				console.log(err);
			})
		});
	}

	static fetchApiData(request?:IfcProductFilteringRequest) {
		return fetch(API_URL, {
			method: "POST",
			body: JSON.stringify(request),
			headers: {
				"Content-type": "application/json"
			}
		}).then((response) => {
			return response.json().then((data) => {
				return data;
			}).catch((err) => {
				console.log(err);
			})
		});
	}
}
